import z from "zod";

import { availabilityWindowSchema } from "@/components/availability-picker";

import { ProfileSchema } from "./profile";
import { ShiftListSchemaResponse } from "./shift";

export const SearchRequestSchema = z.object({
  query: z.string().optional(),
  center: z.object({ lat: z.number(), lng: z.number() }).optional(),
  radiusMiles: z.number().optional(),
  business_id: z.union([z.string(), z.number()]).optional(),
  page_size: z.number().optional(),
  page: z.number().optional(),
  status: z.string().optional(),
  windows: z.array(availabilityWindowSchema).optional(),
});

export type SearchRequest = z.infer<typeof SearchRequestSchema>;

export const UsersResponseSchema = z.object({
  users: z.array(ProfileSchema),
  message: z.string().nullable(),
  success: z.boolean(),
  total: z.number().optional(),
});

export type UsersResponse = z.infer<typeof UsersResponseSchema>;

export { ShiftListSchemaResponse };
